import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

/**
 * Singleton MSAL instance — created once and reused across the application.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
